import classNames from "classnames";
import { DotsLoader } from "dots-ui/dotsLoader";

interface IAvisLoaderProps {
  /** Specifies whether the loader should be displayed inline. */
  inline?: boolean;
  className?: string;
}

export function AvisLoader(props: Readonly<IAvisLoaderProps>) {
  const { inline, className } = props;

  const loaderClassName = classNames("avis-loader", className, {
    inline: inline,
  });

  return (
    <div className={loaderClassName}>
      <DotsLoader />
    </div>
  );
}
